class GameOverState extends Phaser.State {

	create() {
		this.bg = this.add.sprite(0, 0, "gameover-bg");
		this.popup = this.add.sprite(130, 0, "gameover-popup");
		this.bigtext = this.add.sprite(250, 50, "gameover-text");
    this.home = this.add.sprite(370, 270, "gameover-home");
    this.retry = this.add.sprite(330, 310, "gameover-play-again");

    this.enableNavigation();
	}

  enableNavigation() {
    this.retry.inputEnabled = true;
    this.retry.events.onInputDown.add(this.retryGame, this);

    this.home.inputEnabled = true;
    this.home.events.onInputDown.add(this.goHome, this);
  }

  retryGame() {
    this.state.start('GameState');
  }

  goHome() {
    this.state.start('MenuState');
  }
}

export default GameOverState;
